<template>
  <div>
    <b-navbar type="dark" variant="info" style="justify-content: space-between;">
      <b-navbar-brand>
        <img :src="require('@/assets/logo.png')" class="d-inline-block align-top" alt="logo" width="6%"
             height="6%" />
        线路人形监控系统
      </b-navbar-brand>
      <div class="right">
        <div v-if="role == '0'" style="padding: 0 50px 0 0;cursor: pointer; font-size: 18px;color: #fff;"
             @click="navigateToSettings">系统设置
        </div>
        <div v-if="role == '0'" style="padding: 0 50px 0 0;cursor: pointer; font-size: 18px;color: #fff;"
             @click="navigateToControl">监控点管理
        </div>
        <div style="cursor: pointer" @click="navigateToUser" v-if="role == '0'">
          <img :src="require('@/assets/user.png')" class="d-inline-block align-top" alt="logo" width="50px"
               height="50px" />
        </div>
        <div style="padding: 0 50px 0 50px;cursor: pointer; font-size: 18px;color: #fff;" @click="navigateToLogout">
          退出
        </div>
      </div>
    </b-navbar>
    <b-container fluid class="mt-2">
      <b-card no-body>
        <b-breadcrumb>
          <b-breadcrumb-item @click="navigateToHome">
            <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
            首页
          </b-breadcrumb-item>
          <b-breadcrumb-item active>监控点管理</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="btn1">
          <button type="button" class="btn btn-info" style="margin-right: 40px;" @click="handleOpenAddUser">
            添加道口信息
          </button>
        </div>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">序号</th>
            <th scope="col">线名</th>
            <th scope="col">工务段</th>
            <th scope="col">道口名称</th>
            <th scope="col">里程</th>
            <th scope="col">设备编号</th>
            <th scope="col">sim</th>
            <th scope="col">厂商</th>
            <th scope="col">订阅情况</th>
            <th scope="col">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ index + 1 }}</td>
            <td v-text="item.lineName"></td>
            <td v-text="item.workSection"></td>
            <td v-text="item.stationName"></td>
            <td v-text="item.distance"></td>
            <td v-text="item.deviceCode"></td>
            <td v-if="item.deviceType == 0">移动</td>
            <td v-else-if="item.deviceType == 1">大华/乐橙</td>
            <td v-if="item.isSubscribe == 0">未订阅</td>
            <td v-else-if="item.isSubscribe == 1">已订阅</td>
            <td>
              <button style="margin-right: 10px;" type="button" class="btn btn-info btn-sm "
                      @click="openLog(item, index)">查看日志
              </button>
              <button style="margin-right: 10px;" type="button" class="btn btn-info btn-sm "
                      @click="navigateToPhoto1(item, index)">查看直播
              </button>
              <button style="margin-right: 10px;" type="button" class="btn btn-info btn-sm "
                      @click="detectionArea(item,index)">检测区域
              </button>
              <button :disabled="index == 0" type="button" style="margin-right: 10px;" class="btn btn-info btn-sm"
                      @click="moveUpStation(index)">上移
              </button>
              <button :disabled="index == items.length-1" type="button" style="margin-right: 10px;"
                      class="btn btn-info btn-sm" @click="moveDownStation(index)">下移
              </button>
              <button style="margin-right: 10px;" type="button" class="btn btn-info btn-sm "
                      @click="handleOpenDevice(item, index)">编辑
              </button>
              <button type="button" class="btn btn-danger btn-sm " @click="del(index)">删除</button>
            </td>
          </tr>
          </tbody>
        </table>
      </b-card>
    </b-container>
    <b-modal no-close-on-backdrop no-close-on-esc v-model="show1" title="道口信息">
      <div class="modal-box">
        <b-form>
          <b-form-group id="input-group-11" label-cols-sm="4" label="线名" label-for="input-11">
            <b-form-input id="input-11" v-model="form1.lineName"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-12" label-cols-sm="4" label="工务段" label-for="input-12">
            <b-form-input id="input-12" v-model="form1.workSection"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-13" label-cols-sm="4" label="道口名" label-for="input-13">
            <b-form-input id="input-13" v-model="form1.stationName"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-14" label-cols-sm="4" label="里程" label-for="input-14">
            <b-form-input id="input-14" v-model="form1.distance"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-1" label-cols-sm="4" label="设备编号(不能重复)" label-for="input-1">
            <b-form-input id="input-1" v-model="form1.deviceCode"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label-cols-sm="4" label="sim" label-for="input-2">
            <b-form-input id="input-2" v-model="form1.sim"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-8" label-cols-sm="4" label="设备厂商" label-for="input-8">
            <b-form-select v-model="addVideoType" :options="videoOptions" @change="editVideoTypeChange"></b-form-select>
          </b-form-group>
          <b-form-group v-if="addVideoType==1" id="input-group-21" label-cols-sm="4" label="直播网址"
                        label-for="input-21">
            <b-form-input id="input-21" v-model="form1.hlsUrl"></b-form-input>
          </b-form-group>
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-button type="reset" variant="danger" @click="show1 = false">取消</b-button>
        <b-button type="submit" @click="handleEditDevice">确认修改</b-button>
      </template>
    </b-modal>
    <b-modal v-model="show2" no-close-on-backdrop no-close-on-esc title="添加道口信息">
      <div class="modal-box">
        <b-form>
          <b-form-group id="input-group-11" label-cols-sm="4" label="线名" label-for="input-11">
            <b-form-input id="input-11" v-model="form2.lineName"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-12" label-cols-sm="4" label="工务段" label-for="input-12">
            <b-form-input id="input-12" v-model="form2.workSection"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-13" label-cols-sm="4" label="道口名" label-for="input-13">
            <b-form-input id="input-13" v-model="form2.stationName"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-14" label-cols-sm="4" label="里程" label-for="input-14">
            <b-form-input id="input-14" v-model="form2.distance"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-1" label-cols-sm="4" label="设备编号(不能重复)" label-for="input-1">
            <b-form-input id="input-1" v-model="form2.deviceCode"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label-cols-sm="4" label="sim" label-for="input-2">
            <b-form-input id="input-2" v-model="form2.sim"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-8" label-cols-sm="4" label="设备厂商" label-for="input-8">
            <b-form-select v-model="addVideoType" :options="videoOptions" @change="addVideoTypeChange"></b-form-select>
          </b-form-group>
          <b-form-group v-if="addVideoType==1" id="input-group-21" label-cols-sm="4" label="直播网址"
                        label-for="input-21">
            <b-form-input id="input-21" v-model="form2.hlsUrl"></b-form-input>
          </b-form-group>
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-button type="reset" variant="danger" @click="show2 = false">取消</b-button>
        <b-button type="submit" variant="primary" @click="handleSaveAddDevice">确定</b-button>
      </template>
    </b-modal>
    <b-modal no-close-on-backdrop no-close-on-esc v-model="show3" size="xl" title="查看日志">
      <b-row>
        <b-col>
          <b-form-textarea v-if="getLogFlag" readonly v-model="form3.logInfo" rows="24" max-rows="24"></b-form-textarea>
          <span v-else>正在加载中...</span>
        </b-col>
        <b-col cols="3">
          <div class="modal-box">
            <b-form>
              <b-form-group id="input-group-1" label="设备编号(不能重复)" label-for="input-1">
                <b-form-input id="input-1" v-model="form3.deviceCode" disabled></b-form-input>
              </b-form-group>
              <b-form-group id="input-group-2" label="日期" label-for="input-2">
                <b-form-datepicker v-model="form3.date" @input="getLogInfo" placeholder="选择时间"
                                   local="en"></b-form-datepicker>
              </b-form-group>
            </b-form>
          </div>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button type="submit" variant="primary" @click="closeLog">确定</b-button>
      </template>
    </b-modal>
    <!-- 移动设备 iframe 直播 -->
    <b-modal no-close-on-backdrop no-close-on-esc scrollable size="xl" hide-footer title="直播"
             ref="modalYD" @hidden="handleModalYDClose">
      <b-row>
        <b-col>
          <iframe :src="YDUrl" style="width: 100%; height: 625px;" ref="iframeYD"
                  allow="autoplay *; microphone *; fullscreen *" allowfullscreen="true" allowtransparency="true"
                  allowusermedia="true" frameBorder="no"></iframe>
        </b-col>
      </b-row>
    </b-modal>
    <!-- 大华/乐橙 m3u8 播放器弹窗（替换video-player为原生video.js） -->
    <b-modal no-close-on-backdrop no-close-on-esc scrollable size="xl" hide-footer title="直播"
             ref="modal" @hidden="destroyVideoPlayer">
      <b-row>
        <b-col>
          <!-- video.js标准DOM，class必须包含video-js -->
          <video ref="videoDom" class="video-js vjs-big-play-centered" style="width:100%;height:625px;"></video>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="detectionModal" title="调整检测区域" size="xl" hide-footer @show="initDetection">
      <div id="imageContainer" class="image-container" style="position: relative;">
        <div class="img-c">
          <img id="imageToCover" :src="photoUrl" style="width: 100%;" alt="图片加载出错" @load="setGridSize">
        </div>
        <div v-if="imageLoaded" class="grid-container" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
          <div v-for="(row, rowIndex) in detectionGrid" :key="`row-${rowIndex}`" class="grid-row">
            <div v-for="(cell, cellIndex) in row" :key="`cell-${rowIndex}-${cellIndex}`"
                 :style="{...getCellStyle(cell), width: cellWidth + 'px', height: cellHeight + 'px' }"
                 class="grid-cell" @mousedown="handleMouseDown(rowIndex, cellIndex)"
                 @mouseover="handleMouseOver(rowIndex)" @mouseup="handleMouseUp">
            </div>
          </div>
        </div>
      </div>
      <div class="detection-button-container">
        <b-button variant="primary" class="mt-3 detection-btn" @click="addDetection" :disabled="isAddSelected">新增</b-button>
        <b-button variant="primary" class="mt-3 detection-btn" @click="deleteDetection" :disabled="isDeleteSelected">消除</b-button>
        <b-button variant="primary" class="mt-3 detection-btn" @click="reverseDetection">反转</b-button>
        <p class="detection-p">（按住鼠标拖动可选择多个区域）</p>
        <b-button variant="outline-primary" class="mt-3 detection-btn-right" @click="hideDetectionModal(currentDevice)">保存</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import videojs from 'video.js'
import '@videojs/http-streaming'

function getCurrentDateFormatted() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export default {
  name: 'Control',
  created() {
    this.role = window.localStorage.getItem('role');
    this.userUuid = window.localStorage.getItem('userUuid')
    this.username = window.localStorage.getItem('username');
    this.password = window.localStorage.getItem('password');
    this.userUuid = window.localStorage.getItem('userUuid')
    this.getDevicelist()
    this.task = setInterval(() => { this.getDevicelist(); }, 10 * 1000);
  },
  data() {
    return {
      detectionGrid: Array.from({length: 18}, () => Array.from({length: 22}, () => 0)),
      cellWidth: 0,
      cellHeight: 0,
      detectionOption: 0,
      imageLoaded: false,
      isAddSelected: false,
      isDeleteSelected: false,
      isMouseDown: false,
      startRowIndex: null,
      startCellIndex: null,
      endRowIndex: null,
      endCellIndex: null,
      currentDevice: '',
      photoUrl: '',
      videoPlayer: null, // video.js实例
      hlsUrl: '', // m3u8地址
      videoOptions: [
        {text: '移动', value: 0},
        {text: '大华/乐橙', value: 1}
      ],
      options: [
        {value: "标清", text: "高清"},
      ],
      selected: "标清",
      username: '',
      password: "",
      userUuid: '',
      items: [],
      satitem: [],
      show1: false,
      show2: false,
      show3: false,
      form1: {},
      form2: {},
      form3: {},
      role: '',
      radioValue: '',
      arrindex: 0,
      task: null,
      getLogFlag: false,
      task2: null,
      gklog: 0,
      playTime: 30,
      Countdown: "00:00:00",
      clickItem: null,
      Timeout: null,
      YDUrl: null,
      upload_file: "",
      lists: [],
      show4: false,
      item: [],
      addVideoType: 0,
      selected2: '',
      index: 0,
      boxOne: '',
      boxTwo: ''
    };
  },
  beforeDestroy() {
    clearInterval(this.task)
    window.removeEventListener('resize', this.setGridSize);
    // 页面销毁释放播放器
    this.destroyVideoPlayer()
  },
  watch: {
    show3(newVal) {
      if (newVal == false) clearInterval(this.task2);
    }
  },
  methods: {
    // 销毁播放器，释放网络与DOM资源
    destroyVideoPlayer() {
      if (this.videoPlayer) {
        this.videoPlayer.dispose()
        this.videoPlayer = null
      }
      this.hlsUrl = ""
      clearInterval(this.timer)
      clearTimeout(this.Timeout)
      this.Countdown = "00:00:00"
    },
    // 初始化播放器加载m3u8
    initPlayer(url) {
      const videoDom = this.$refs.videoDom
      if (!videoDom || !url) return
      this.destroyVideoPlayer()
      this.videoPlayer = videojs(videoDom, {
        autoplay: true,
        muted: true, // 浏览器自动播放必须静音
        language: 'zh-CN',
        controls: true,
        sources: [
          {
            src: url,
            type: 'application/x-mpegURL'
          }
        ],
        notSupportedMessage: '直播流加载失败，地址失效或不支持'
      })
      // 播放错误监听
      this.videoPlayer.on('error', () => {
        alert('直播播放异常，请重新打开窗口')
        this.destroyVideoPlayer()
      })
    },
    initDetection() {
      this.isAddSelected = false
      this.isDeleteSelected = false
      this.isMouseDown = false
      this.startRowIndex = null
      this.startCellIndex = null
      this.endRowIndex = null
      this.endCellIndex = null
      this.detectionOption = 0
    },
    handleMouseDown(rowIndex, cellIndex) {
      this.isMouseDown = true
      this.startRowIndex = rowIndex
      this.startCellIndex = cellIndex
      this.toggleCell(rowIndex, cellIndex)
    },
    handleMouseOver(rowIndex, cellIndex) {
      if (this.isMouseDown && this.detectionOption !== 0) {
        let status = this.detectionOption === 1 ? 1 : 0
        const startRow = Math.min(this.startRowIndex, rowIndex)
        const startCell = Math.min(this.startCellIndex, cellIndex)
        const endRow = Math.max(this.startRowIndex, rowIndex)
        const endCell = Math.max(this.startCellIndex, cellIndex)
        for (let i = startRow; i <= endRow; i++)
          for (let j = startCell; j <= endCell; j++)
            this.$set(this.detectionGrid[i], j, status)
      }
    },
    handleMouseUp() {
      this.isMouseDown = false
    },
    setGridSize() {
      const image = document.getElementById('imageToCover');
      this.cellWidth = image.offsetWidth / 22;
      this.cellHeight = image.offsetHeight / 18;
      this.imageLoaded = true;
    },
    getCellStyle(cellValue) {
      const color = cellValue === 1 ? 'rgba(245,130,22,0.6)' : 'rgba(128,128,0.3)';
      const borderColor = cellValue === 1 ? 'rgba(245,130,22,0.4)' : '#888';
      return { backgroundColor: color, borderColor }
    },
    toggleCell(rowIndex, cellIndex) {
      this.$set(this.detectionGrid[rowIndex], cellIndex, this.detectionOption === 1 ? 1 : 0)
    },
    addDetection() {
      this.detectionOption = 1
      this.isAddSelected = true; this.isDeleteSelected = false;
    },
    reverseDetection() {
      this.detectionGrid = this.detectionGrid.map(row => row.map(c => c ? 0 : 1))
    },
    deleteDetection() {
      this.detectionOption = 2
      this.isAddSelected = false; this.isDeleteSelected = true;
    },
    detectionArea(item) {
      this.getLastImageName(item.deviceCode)
      this.getDetection(item.deviceCode)
      this.currentDevice = item.deviceCode
    },
    hideDetectionModal(deviceCode) {
      this.$bvModal.msgBoxConfirm('确定保存？').then(v => {
        if (v) {
          this.$refs.detectionModal.hide();
          this.setDetection(deviceCode)
        }
      })
    },
    binaryRowsToDecimalArray() {
      return this.detectionGrid.map(row => parseInt(row.join(''), 2))
    },
    decimalArrayToBinaryGrid(arr) {
      return arr.map(n => n.toString(2).padStart(22, '0').split('').map(Number))
    },
    navigateToUser() { this.$router.push('/usermanage') },
    navigateToControl() { this.$router.push('/control') },
    navigateToHome() { this.$router.push('/home') },
    navigateToSettings() { this.$router.push('/settings') },
    getLastImageName(deviceCode) {
      axios.get(`${this.$apiRoot}/image/last?deviceCode=${deviceCode}`).then(res => {
        this.photoUrl = `${this.$apiRoot}/deviceSim/img/${deviceCode}/${res.data.data}.jpg`
      })
    },
    getDetection(deviceId) {
      axios.get(`${this.$apiRoot}/deviceAlarm/getDeviceAlarmRegion?deviceId=${deviceId}`).then(res => {
        this.detectionGrid = this.decimalArrayToBinaryGrid(res.data.data.split(',').map(Number))
        this.$refs.detectionModal.show()
      })
    },
    setDetection(deviceId) {
      const region = this.binaryRowsToDecimalArray().join(',')
      axios.get(`${this.$apiRoot}/deviceAlarm/setDeviceAlarmRegion?deviceId=${deviceId}&region=${region}`)
    },
    addVideoTypeChange() { this.form2.deviceType = this.addVideoType },
    editVideoTypeChange() { this.form1.deviceType = this.addVideoType },
    handleEditDevice() {
      if (!this.form1.deviceCode || !this.form1.sim || !this.form1.stationName) {
        alert('设备编号、sim、道口名不能为空')
        return
      }
      if (this.form1.deviceType == 0) this.form1.hlsUrl = ''
      axios.post(`${this.$apiRoot}/deviceSim/edit`, this.form1).then(res => {
        if (res.data.code === 200) {
          this.getDevicelist()
          this.show1 = false
        } else alert(res.data.message)
      })
    },
    navigateToLogout() {
      this.$bvModal.msgBoxConfirm('是否退出登录?').then(v => {
        if (v) {
          localStorage.clear()
          this.$router.push('/login')
        }
      })
    },
    moveUpStation(index) {
      axios.post(`${this.$apiRoot}/deviceSim/moveStation?stationUuid=${this.items[index].uuid}&isDown=false`)
        .then(res => res.data.code === 200 && this.getDevicelist())
    },
    moveDownStation(index) {
      axios.post(`${this.$apiRoot}/deviceSim/moveStation?stationUuid=${this.items[index].uuid}&isDown=true`)
        .then(res => res.data.code === 200 && this.getDevicelist())
    },
    closeLog() { this.show3 = false },
    ptzController(item, op) {
      axios.get(`${this.$apiRoot}/imou/controlMovePTZ?deviceId=${item.deviceCode}&operation=${op}`)
    },
    downTiem(h, m, s) {
      let remain = (h * 3600 + m * 60 + s) * 1000
      this.timer = setInterval(() => {
        remain -= 1000
        if (remain >= 0) {
          let hh = Math.floor(remain / 3600000) % 24
          let mm = Math.floor((remain % 3600000) / 60000)
          let ss = Math.floor((remain % 60000) / 1000)
          this.Countdown = `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`
        } else {
          clearInterval(this.timer)
          this.Countdown = '00:00:00'
        }
      }, 1000)
    },
    async navigateToPhoto1(item) {
      if (item.deviceType === 0) await this.getWebSDKUrl(item)
      else await this.getLiveStreamInfo(item)
    },
    getWebSDKUrl(item) {
      axios.get(`${this.$apiRoot}/andmu/getWebSdkUrl/${item.deviceCode}`).then(res => {
        if (res.data.code === 200) {
          this.YDUrl = res.data.data.url
          this.$refs.modalYD.doShow()
        } else if (res.data.message === 'token已过期(11504)') {
          axios.get(`${this.$apiRoot}/andmu/setAccessToken`).then()
          alert('token过期，已重新获取，请重试')
        } else alert(res.data.message)
      })
    },
    handleModalYDClose() { this.YDUrl = '' },
    // 获取乐橙/大华m3u8地址并播放
    getLiveStreamInfo(item) {
      axios.get(`${this.$apiRoot}/imou/getLiveStreamInfo?deviceId=${item.deviceCode}`).then(res => {
        if (res.data.code !== 200) {
          alert(res.data.message)
          return
        }
        // 取主码流streamId=1的m3u8
        let m3u8Src = ''
        res.data.data.forEach(stream => {
          if (stream.streamId === 1) m3u8Src = stream.hls
        })
        if (!m3u8Src) {
          alert('未获取到m3u8直播地址')
          return
        }
        this.hlsUrl = m3u8Src
        clearTimeout(this.Timeout)
        clearInterval(this.timer)
        this.downTiem(0, 0, this.playTime)
        this.clickItem = item
        // 倒计时结束自动销毁播放器
        this.Timeout = setTimeout(() => this.destroyVideoPlayer(), this.playTime * 1000)
        // 打开弹窗，DOM渲染完成后初始化播放器
        this.$refs.modal.doShow()
        this.$nextTick(() => this.initPlayer(this.hlsUrl))
      })
    },
    getLogInfo() {
      this.form3.logInfo = '加载中...'
      this.getLogFlag = false
      axios.get(`${this.$apiRoot}/system/getLog/${this.form3.deviceCode}/${this.form3.date}`).then(res => {
        this.form3.logInfo = res.data
        this.getLogFlag = true
      })
    },
    openLog(item) {
      this.form3.deviceCode = item.deviceCode
      this.form3.date = getCurrentDateFormatted()
      this.getLogInfo()
      this.task2 = setInterval(() => this.getLogInfo(), 5000)
      this.show3 = true
    },
    getDevicelist() {
      axios.get(`${this.$apiRoot}/deviceSim/list`).then(res => {
        this.items = res.data.data
      })
    },
    handleOpenAddUser() {
      this.form2 = { lineName:'',workSection:'',stationName:'',distance:'',deviceCode:'',sim:'',deviceType:0,hlsUrl:'' }
      this.addVideoType = 0
      this.show2 = true
    },
    handleSaveAddDevice() {
      if (!this.form2.deviceCode || !this.form2.sim || !this.form2.stationName) {
        alert('必填项不能为空')
        return
      }
      if (this.form2.deviceType === 0) this.form2.hlsUrl = ''
      axios.post(`${this.$apiRoot}/deviceSim/add`, this.form2).then(res => {
        if (res.data.code === 200) {
          this.getDevicelist()
          this.show2 = false
        } else alert(res.data.message)
      })
    },
    handleOpenDevice(item) {
      this.form1 = { ...item }
      this.addVideoType = item.deviceType
      this.show1 = true
    },
    del(index) {
      this.$bvModal.msgBoxConfirm('确认删除？').then(v => {
        if (v) {
          axios.post(`${this.$apiRoot}/deviceSim/delete`, this.items[index]).then(res => {
            res.data.code === 200 ? this.getDevicelist() : alert('删除失败')
          })
        }
      })
    }
  },
  mounted() {
    window.addEventListener('resize', this.setGridSize);
  }
}
</script>

<style>
.detection-button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.detection-btn {
  margin-right: 10px;
}
.detection-btn-right {
  margin-left: auto;
}
.image-container {
  position: relative;
}
.img-c {
  width: 100%;
  position: relative;
  padding-bottom: 56.3%;
  background-color: #eee;
  overflow: hidden;
}
.image-container img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
}
.grid-container {
  display: flex;
  flex-direction: column;
  user-select: none;
}
.grid-row {
  display: flex;
}
.grid-cell {
  border: 1px solid grey;
  margin: 0;
  cursor: pointer;
}
.btn2 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding-bottom: 20px;
}
.btn1 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding-bottom: 20px;
}
img {
  user-select: none;
  pointer-events: none;
}
.detection-p {
  display: inline-block;
  font-size: small;
  color: #cbbdbd;
  margin-top: 30px;
}
</style>
